<div
    class="spinner-border"
    role="status"
    [ngClass]="themeClass"
    [class.spinner-border-sm]="small"
>
    <span class="visually-hidden">Loading...</span>
</div>
